import { defineComponent, ref, computed, watch, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, toDisplayString, createBlock, resolveDynamicComponent, createCommentVNode } from "vue";
import OfflineIcon from "../../assets/icons/offline.svg.js";
import OnlineIcon from "../../assets/icons/online.svg.js";
import VerifyTickIcon from "../../assets/icons/verify-tick.svg.js";
const _hoisted_1 = { class: "avatar-wrapper" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
  key: 1,
  class: "avatar__initials"
};
const _hoisted_4 = {
  key: 2,
  class: "avatar__fallback",
  fill: "none",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_5 = {
  key: 0,
  class: "avatar__content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Avatar",
  props: {
    size: { default: "md" },
    title: { default: "" },
    subtitle: { default: "" },
    avatarUrl: { default: "" },
    variant: { default: "round" },
    showTitles: { type: Boolean, default: true },
    indicator: { default: "none" },
    companyBadge: { default: null },
    imageFit: { default: "cover" }
  },
  setup(__props) {
    const props = __props;
    const imageError = ref(false);
    const handleImageError = () => {
      imageError.value = true;
    };
    const displayInitials = computed(() => {
      if (!props.title) return "";
      const words = props.title.trim().split(" ").filter(Boolean);
      if (words.length === 0) return "";
      if (words.length === 1) return words[0].charAt(0).toUpperCase();
      return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
    });
    const hasLabel = computed(() => (props.title || props.subtitle) && props.showTitles);
    const indicatorComponent = computed(() => {
      switch (props.indicator) {
        case "online":
          return OnlineIcon;
        case "offline":
          return OfflineIcon;
        case "verify-tick":
          return VerifyTickIcon;
        case "company-badge":
          return props.companyBadge;
        default:
          return null;
      }
    });
    const showIndicator = computed(() => props.indicator !== "none" && indicatorComponent.value !== null);
    watch(
      () => props.avatarUrl,
      () => {
        imageError.value = false;
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["avatar-container", `avatar-container--${__props.variant}`])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", {
            class: normalizeClass(["avatar", `avatar--${__props.size}`, `avatar--${__props.variant}`])
          }, [
            __props.avatarUrl && !imageError.value ? (openBlock(), createElementBlock("img", {
              key: 0,
              src: __props.avatarUrl,
              alt: __props.title || "Avatar",
              class: "avatar__image",
              style: normalizeStyle({ objectFit: __props.imageFit }),
              onError: handleImageError
            }, null, 44, _hoisted_2)) : displayInitials.value ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(displayInitials.value), 1)) : (openBlock(), createElementBlock("svg", _hoisted_4, [..._cache[0] || (_cache[0] = [
              createElementVNode("path", {
                d: "M26.6666 28C26.6666 26.1392 26.6666 25.2089 26.4369 24.4518C25.9199 22.7473 24.586 21.4134 22.8814 20.8963C22.1244 20.6667 21.194 20.6667 19.3332 20.6667H12.6666C10.8058 20.6667 9.87546 20.6667 9.1184 20.8963C7.41386 21.4134 6.07997 22.7473 5.5629 24.4518C5.33325 25.2089 5.33325 26.1392 5.33325 28M21.9999 10C21.9999 13.3137 19.3136 16 15.9999 16C12.6862 16 9.99992 13.3137 9.99992 10C9.99992 6.68629 12.6862 4 15.9999 4C19.3136 4 21.9999 6.68629 21.9999 10Z",
                stroke: "currentColor",
                "stroke-width": "2.67",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, -1)
            ])]))
          ], 2),
          showIndicator.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["avatar__indicator", `avatar__indicator--${__props.size}`])
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(indicatorComponent.value), { class: "avatar__indicator-icon" }))
          ], 2)) : createCommentVNode("", true)
        ]),
        hasLabel.value ? (openBlock(), createElementBlock("div", _hoisted_5, [
          __props.title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["avatar__title", `avatar__title--${__props.size}`])
          }, toDisplayString(__props.title), 3)) : createCommentVNode("", true),
          __props.subtitle ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["avatar__subtitle", `avatar__subtitle--${__props.size}`])
          }, toDisplayString(__props.subtitle), 3)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Avatar.vue2.js.map
